import { NgModule } from '@angular/core';
import {
  FormArrayModule,
  FormAutocompleteModule,
  FormButtonModule,
  FormCheckboxBooleanModule,
  FormCheckboxModule,
  FormDatepickerModule,
  FormFileModule,
  FormInputModule,
  FormMatSelectModule,
  FormOtpModule,
  FormRadioModule,
  FormSelectModule,
  FormSignatureModule,
  FormSingleButtonModule,
  FormSliderModule,
} from './field-type';
import { PortalFormValidationModule } from './validation';

@NgModule({
  imports: [
    FormArrayModule,
    FormAutocompleteModule,
    FormButtonModule,
    FormCheckboxBooleanModule,
    FormCheckboxModule,
    FormDatepickerModule,
    FormFileModule,
    FormInputModule,
    FormMatSelectModule,
    FormOtpModule,
    FormRadioModule,
    FormSelectModule,
    FormSignatureModule,
    FormSingleButtonModule,
    FormSliderModule,
    PortalFormValidationModule,
  ],
})
export class FormlyPortalFormModule {}
